import React, { useState, useEffect } from 'react';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';
import NovoCertificado from './NovoCertificado';

//Api
import certificado_api from '../../../api/certificado_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

export default function FichaCertificado({ tipoDocumento, loading, setLoading, btnVoltar, permissao }) {
    //Guarada os certificados
    const [certificados, setCertificados] = useState([]);

    //Controle da tela de novo/editar certificado
    const [novoCertificado, setNovoCertificado] = useState(false);

    //Controle para editar certificado
    const [editarCertificado, setEditarCertificado] = useState(null);

    //Cabeçalhos da tabela de certificados
    const headersTabela = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Situação", objectValue: "situacao", align: "left" },
    ]

    //função do botão editar da tabela de certificados
    const editar = (item) => {
        setEditarCertificado(item.id);
    }

    //função do botão adicionar
    const novo = () => setNovoCertificado(true);

    //função de voltar para a tela de adicionar ou editar certificado
    const btnVoltarFicha = () => {
        setEditarCertificado(null);
        setNovoCertificado(false);
        loadCertificados();
    }

    //carrega os certificados
    const loadCertificados = () => {
        setLoading(true);
        certificado_api.GetList(tipoDocumento).then(response => {
            setCertificados(response.data);
            setLoading(false);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        })
    }

    //Variavel que guarda as ações da tabela
    const actions = [];
    if (permissao === "Editar") {
        actions.push(actionsTable.editar(editar))
    }

    //carrega os certificados ao inicializar a tela
    useEffect(() => {
        loadCertificados();
    }, [])

    if (novoCertificado) {
        return <NovoCertificado 
            tipoDocumento={tipoDocumento} 
            loading={loading} 
            setLoading={setLoading} 
            btnVoltar={btnVoltarFicha} 
        />
    }

    if (editarCertificado != null) {
        return <NovoCertificado 
            id={editarCertificado} 
            loading={loading} 
            setLoading={setLoading} 
            tipoDocumento={tipoDocumento} 
            btnVoltar={btnVoltarFicha} 
        />
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnVoltar={btnVoltar} btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={novo}>
                <div className="mt-4">
                    <TabelaListagem actions={actions} title='Lista de certificados' headers={headersTabela} items={certificados} options={{ print: false, search: true, pagination: true }} />
                </div>
            </MainCard>
        </>
    )
}